import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import PrimePaginator from '../utilities/primePaginator';
import toast from 'react-hot-toast';

import apiCall from '../../helperFunctions/apiCall';
import { getGroups } from '../utilities/auth/authAPI';

import GroupCard from './groupCard';
import { Loading } from '../utilities/helpers';

const defaultRows = 6;


function GroupsList(props) {

  // Define variables
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [groups, setGroups] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(defaultRows);
  const [totalGroups, setTotalGroups] = useState(defaultRows);
  const orgId = props.orgId;


  // Component load actions
  useEffect(() => {
    loadGroupsData(1);

    // Reset in the event we changed org id
    setFirst(0);
    setRows(defaultRows);
  }, [orgId]);


  // Define functions
  function loadGroupsData(newPage) {

    if( !orgId ) { return }

    const payload = {orgId: orgId, page: newPage};

    apiCall(getGroups, payload).then((response) => {
      if( response.success ) {
        setGroups(response.data.groups);
        setTotalGroups(response.data.total_group_count);
      } else {
        toast.error(response.error);
      }
    }).finally(() => {
      setTimeout(() => setIsLoading(false), 1000);
    });
  }

  function onPageChange(event) {
    const newPage = event.page + 1;
    loadGroupsData(newPage);

    setFirst(event.first);
    setRows(event.rows);
  }


  // Screen components
  let bodyElement = <div style={{marginTop: '200px'}}><Loading /></div>;
  if( !isLoading ) {

    let paginatorElement;
    if( totalGroups > rows ) {
      paginatorElement = (
        <div style={{marginTop: '30px'}}>
          <PrimePaginator
            totalRecords={totalGroups}
            rows={rows}
            first={first}
            onPageChange={onPageChange}
          />
        </div>
      );
    }

    bodyElement = (
      <div style={{width: '100%'}}>
        <div class='flex-row flex-wrap group-cards-container'>
          {groups.map((group, index) =>
            <GroupCard
              group={group}
              key={index}
              navigate={navigate}
            />
          )}
        </div>
        {paginatorElement}
      </div>
    );
  }


  return (
    <div class='flex-column' style={{minHeight: '600px'}}>
      {bodyElement}
    </div>
  );
}

export default GroupsList;